import { useTranslate } from 'react-admin'
import type { ProposalTemplateType } from 'types/proposalTemplate'
import TemplateLibraryCard, { CustomTemplateLibraryCardProps } from './TemplateLibraryCard'

type ProposalV2TemplateCardProps = CustomTemplateLibraryCardProps & {
  template: ProposalTemplateType
  title: string
}

const ProposalV2TemplateCard = (props: ProposalV2TemplateCardProps) => {
  const { template } = props
  const translate = useTranslate()

  const imgSrc = template?.proposal_image_file_contents || `${window.PUBLIC_URL}/images/proposal/template_default.png`

  // const description = template?.description || ''

  return (
    <TemplateLibraryCard
      {...props}
      body={translate('Slide-based interactive lifestyle proposal')}
      header={props.title || template?.title || ''}
      imgSrc={imgSrc}
      tag={template.is_updated ? translate('Updated') : undefined}
    />
  )
}

export default ProposalV2TemplateCard
